import React from 'react';
export var AccordionContext = React.createContext(undefined);
//# sourceMappingURL=AccordionContext.js.map